const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: "cryptoverse-44df8.firebaseapp.com",
  projectId: "cryptoverse-44df8",
  storageBucket: "cryptoverse-44df8.appspot.com",
  messagingSenderId: "560967364913",
  appId: "1:560967364913:web:ac177a20a6bbc383df0010",
};

export default firebaseConfig;
